import {RankedPlacementState} from '@colonist/leaderboard-types'
import {T} from '../../../../common/T'
import styles from './PlacementChange.module.scss'
import rankedStyles from '../RankedScreen.module.scss'
import React from 'react'
import {Button} from '../../../../common/Button'

export function PlacementChange({
    rankedState,
    onContinue,
}: {
    rankedState: RankedPlacementState
    onContinue: VoidFunction
}) {
    const popupStatusText = rankedState.getFindGamePopupStatusText()
    const updateText = rankedState.getEndGameScreenUpdateText()

    return (
        <div className={styles.container}>
            <div className={styles.contentContainer}>
                <div className={styles.content}><T id={popupStatusText}/></div>
                <div className={styles.content}><T id={updateText}/></div>
            </div>

            <div className={styles.buttonContainer}>
                <Button
                    className={rankedStyles.continueButton}
                    onClick={onContinue}
                >
                    <T id={{key: 'strings:game.endGame.footer.continue'}}/>
                </Button>
            </div>
        </div>
    )
}
